import RequestPending from './RequestPending';

export default RequestPending;
